import { db, storage } from './config';
import { 
  collection, doc, addDoc, getDoc, getDocs, updateDoc, deleteDoc, 
  query, where, orderBy, serverTimestamp, increment
} from 'firebase/firestore';
import { ref, uploadBytes, getDownloadURL, deleteObject } from 'firebase/storage';

// Koleksiyon referansı
const articlesRef = collection(db, 'articles');

// Tüm makaleleri getir
export const getAllArticles = async () => {
  try {
    console.log("getAllArticles fonksiyonu çağrıldı");
    const q = query(articlesRef, orderBy('createdAt', 'desc'));
    const snapshot = await getDocs(q);
    
    console.log("Veri çekme başarılı, belge sayısı:", snapshot.size);
    
    return snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));
  } catch (error) {
    console.error('Makaleler getirilirken hata:', error);
    throw error;
  }
};

// ID'ye göre makale getir
export const getArticleById = async (id) => {
  try {
    const docRef = doc(db, 'articles', id);
    const docSnap = await getDoc(docRef);
    
    if (docSnap.exists()) {
      return {
        id: docSnap.id,
        ...docSnap.data()
      };
    } else {
      throw new Error('Makale bulunamadı');
    }
  } catch (error) {
    console.error('Makale getirilirken hata:', error);
    throw error;
  }
};

// Slug'a göre makale getir
export const getArticleBySlug = async (slug) => {
  try {
    const q = query(articlesRef, where('slug', '==', slug));
    const snapshot = await getDocs(q);
    
    if (snapshot.empty) {
      throw new Error('Makale bulunamadı');
    }
    
    return {
      id: snapshot.docs[0].id,
      ...snapshot.docs[0].data()
    };
  } catch (error) {
    console.error('Slug ile makale getirilirken hata:', error);
    throw error;
  }
};

// Yeni makale oluştur
export const createArticle = async (articleData, authorEmail) => {
  try {
    // Eğer slug yoksa, başlıktan otomatik oluştur
    if (!articleData.slug && articleData.title) {
      articleData.slug = createSlug(articleData.title);
    }
    
    const newArticle = {
      ...articleData,
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp(),
      viewCount: 0,
      authorEmail
    };
    
    const docRef = await addDoc(articlesRef, newArticle);
    return docRef.id;
  } catch (error) {
    console.error('Makale oluşturulurken hata:', error);
    throw error;
  }
};

// Makale güncelle
export const updateArticle = async (id, articleData) => {
  try {
    const articleRef = doc(db, 'articles', id);
    
    await updateDoc(articleRef, {
      ...articleData,
      updatedAt: serverTimestamp()
    });
    
    return true;
  } catch (error) {
    console.error('Makale güncellenirken hata:', error);
    throw error;
  }
};

// Makale sil
export const deleteArticle = async (id) => {
  try {
    const articleRef = doc(db, 'articles', id);
    await deleteDoc(articleRef);
    return true;
  } catch (error) {
    console.error('Makale silinirken hata:', error);
    throw error;
  }
};

// Makale yayınlama durumunu değiştir
export const toggleArticlePublishStatus = async (id, isPublished) => {
  try {
    const articleRef = doc(db, 'articles', id);
    
    await updateDoc(articleRef, {
      isPublished,
      updatedAt: serverTimestamp()
    });
    
    return true;
  } catch (error) {
    console.error('Makale durumu değiştirilirken hata:', error);
    throw error;
  }
};

// Görüntülenme sayısını artır
export const incrementArticleViewCount = async (id) => {
  try {
    const articleRef = doc(db, 'articles', id);
    
    await updateDoc(articleRef, {
      viewCount: increment(1)
    });
    
    return true;
  } catch (error) {
    console.error('Görüntülenme sayısı artırılırken hata:', error);
    throw error;
  }
};

// Kategoriye göre makaleleri getir
export const getArticlesByCategory = async (categoryId) => {
  try {
    const q = query(
      articlesRef,
      where('categoryId', '==', categoryId),
      where('isPublished', '==', true),
      orderBy('createdAt', 'desc')
    );
    const snapshot = await getDocs(q);
    
    return snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));
  } catch (error) {
    console.error('Kategoriye göre makaleler getirilirken hata:', error);
    throw error;
  }
};

// Resim yükle ve URL döndür
export const uploadArticleImage = async (file) => {
  try {
    const timestamp = Date.now();
    const fileName = `${timestamp}_${file.name}`;
    const storageRef = ref(storage, `articles/${fileName}`);
    
    await uploadBytes(storageRef, file);
    const downloadURL = await getDownloadURL(storageRef);
    
    return downloadURL;
  } catch (error) {
    console.error('Resim yüklenirken hata:', error);
    throw error;
  }
};

// Resim sil
export const deleteArticleImage = async (imageUrl) => {
  try {
    // Eğer URL yoksa işlem yapma
    if (!imageUrl) return true;
    
    // URL'den dosya yolunu çıkarmaya çalış
    const imageRef = ref(storage, imageUrl);
    await deleteObject(imageRef);
    return true;
  } catch (error) {
    console.error('Resim silinirken hata:', error);
    throw error;
  }
};

// Yardımcı fonksiyon: Başlıktan URL-dostu slug oluştur
const createSlug = (title) => {
  return title
    .toLowerCase()
    .replace(/ğ/g, 'g')
    .replace(/ü/g, 'u')
    .replace(/ş/g, 's')
    .replace(/ı/g, 'i')
    .replace(/ö/g, 'o')
    .replace(/ç/g, 'c')
    .replace(/[^a-z0-9]/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');
};